const indexItems = [
  {
    icon: 'ri-movie-line',
    title: '娱乐圈大瓜汇总',
    desc: '明星恋情、婚姻变故、合约纠纷等娱乐圈最新爆料一网打尽',
    tag: '热门',
    tagColor: 'bg-primary-500/80',
  },
  {
    icon: 'ri-user-voice-line',
    title: '网红黑料档案',
    desc: '头部主播、短视频网红翻车记录与争议事件完整档案',
    tag: '更新中',
    tagColor: 'bg-accent-500/80',
  },
  {
    icon: 'ri-building-line',
    title: '企业内幕曝光',
    desc: '知名企业财务造假、内部斗争、高管变动等深度调查报道',
    tag: '独家',
    tagColor: 'bg-primary-500/80',
  },
  {
    icon: 'ri-fire-line',
    title: '社会热点追踪',
    desc: '社会事件、公共议题相关的争议爆料与多方视角还原',
    tag: '热议',
    tagColor: 'bg-accent-500/80',
  },
  {
    icon: 'ri-computer-line',
    title: '科技圈吃瓜指南',
    desc: '科技公司裁员、产品翻车、创始人言论争议等科技圈八卦',
    tag: '新',
    tagColor: 'bg-primary-500/80',
  },
  {
    icon: 'ri-global-line',
    title: '海外猛料速递',
    desc: '国际娱乐圈、商业圈重大爆料事件的汉化整理与深度解读',
    tag: '速递',
    tagColor: 'bg-accent-500/80',
  },
  {
    icon: 'ri-archive-line',
    title: '历史经典爆料',
    desc: '历年重大爆料事件回顾，经典吃瓜名场面完整存档',
    tag: '经典',
    tagColor: 'bg-secondary-500/80',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热门专题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            按类别快速定位你感兴趣的吃瓜领域，每个专题持续更新最新爆料内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.slice(0, 3).map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group bg-background-200/80 border border-background-300/30 rounded-xl p-5 hover:border-primary-500/30 transition-all cursor-pointer"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-background-100 rounded-lg flex-shrink-0 group-hover:bg-primary-500/10 transition-colors">
                  <i className={`${item.icon} text-lg text-primary-400`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm font-medium text-foreground-800 truncate">{item.title}</h3>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded text-background-50 whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </div>
            </a>
          ))}
          {indexItems.slice(3, 4).map((item, i) => (
            <a
              key={i + 3}
              href="#cards"
              className="group bg-background-200/80 border border-background-300/30 rounded-xl p-5 hover:border-primary-500/30 transition-all cursor-pointer sm:col-span-2"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-background-100 rounded-lg flex-shrink-0 group-hover:bg-primary-500/10 transition-colors">
                  <i className={`${item.icon} text-lg text-primary-400`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm font-medium text-foreground-800 truncate">{item.title}</h3>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded text-background-50 whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </a>
          ))}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:col-span-2 lg:col-span-4">
            {indexItems.slice(4).map((item, i) => (
              <a
                key={i + 4}
                href="#cards"
                className="group bg-background-200/80 border border-background-300/30 rounded-xl p-5 hover:border-primary-500/30 transition-all cursor-pointer"
              >
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-background-100 rounded-lg flex-shrink-0 group-hover:bg-primary-500/10 transition-colors">
                    <i className={`${item.icon} text-lg text-primary-400`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="text-sm font-medium text-foreground-800 truncate">{item.title}</h3>
                      <span className={`text-[10px] px-1.5 py-0.5 rounded text-background-50 whitespace-nowrap ${item.tagColor}`}>
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}